import PropTypes from 'prop-types'
import {
  Link,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  OrderedList,
  ListItem,
  Text,
  Button,
  Box,
} from '@chakra-ui/react'
import {useTranslation, Trans} from 'react-i18next'

import {
  conversionRatePartnerShape,
  conversionRateValues,
} from './conversionRate'
import {
  QANTAS_TERMS_AND_CONDITIONS_URL,
  QANTAS_PRIVACY_POLICY_URL,
} from './Urls'

const TermsAndConditionsModal = ({isOpen, onClose, partner}) => {
  const {t} = useTranslation('points')

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxH="80vh">
        <ModalHeader>
          {t('points:connectionDrawer.termsModal.qantas.title')}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Box>
            <OrderedList>
              {[
                'conversion',
                'eligibility',
                'accountConnection',
                'processingTime',
                'privacy',
                'dataSharing',
              ].map((key) => (
                <ListItem key={key}>
                  <Text textStyle="caption-medium" mb="sm">
                    {t(`points:qantasConnectionDrawer.termsModal.${key}.title`)}
                  </Text>
                  <Text textStyle="body-copy" mb="sm">
                    <Trans
                      t={t}
                      i18nKey={`points:qantasConnectionDrawer.termsModal.${key}.content`}
                      values={conversionRateValues(partner)}
                      components={{
                        QantasTermsLink: (
                          <Link
                            textDecoration="underline"
                            href={QANTAS_TERMS_AND_CONDITIONS_URL}
                            isExternal
                          />
                        ),
                        QantasPrivacyLink: (
                          <Link
                            textDecoration="underline"
                            href={QANTAS_PRIVACY_POLICY_URL}
                            isExternal
                          />
                        ),
                      }}
                    />
                  </Text>
                </ListItem>
              ))}
            </OrderedList>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button variant="primary" onClick={onClose}>
            {t('points:connectionDrawer.termsModal.closeButton')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

TermsAndConditionsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  partner: conversionRatePartnerShape,
}

TermsAndConditionsModal.defaultProps = {
  partner: null,
}

export default TermsAndConditionsModal
